import Session from 'app/models/session';

import { showError, showResponseError } from 'utils/messages';
import { setLocation } from 'utils/wrappers';
import { clearStoredValue } from 'utils/storage';

import Base from 'app/views/base';
import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit #login-form': 'logIn',
  },

  initialize({ redirect }) {
    this.model = new Session({});
    this.redirect = redirect;
  },

  context() {
    return {
      email: this.model.get('email'),
    };
  },

  logIn(e) {
    e.preventDefault();
    const self = this;

    this.model.save({
      email: this.$('input#session-email').val(),
      password: this.$('input#session-password').val(),
    }, {
      success() {
        setLocation(self.redirect || clearStoredValue('signinLocation') || '/account/shipments');
      },
      error(model, response) {
        self.model.unset('password');
        self.render();
        if (response.status >= 500) {
          showError('There was a problem communicating with the EasyPost servers. You may continue using the logged-out functionality of the website while this problem is resolved.');
        } else {
          showResponseError(response);
        }
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/sign_in/index.js